(function () {
  "use strict";

  if (window.__progressiveMediaAssets) return;
  window.__progressiveMediaAssets = true;

  function initProgressiveMedia(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var images = root.querySelectorAll("img.progressive-media");
    Array.prototype.forEach.call(images, function (img) {
      if (img.getAttribute("data-progressive-media-ready") === "1") return;
      img.setAttribute("data-progressive-media-ready", "1");

      var markLoaded = function () {
        img.classList.add("is-loaded");
      };

      if (img.complete && img.naturalWidth > 0) {
        markLoaded();
        return;
      }

      img.addEventListener("load", markLoaded, { once: true });
      img.addEventListener("error", markLoaded, { once: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initProgressiveMedia(document);
    });
  } else {
    initProgressiveMedia(document);
  }

  document.addEventListener("shopify:section:load", function (ev) {
    initProgressiveMedia(ev.target || document);
  });
})();
